import React, { useState, useEffect } from 'react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      // Wechsel nach 150px scrollen
      setIsScrolled(scrollTop > 150);
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <a href="#home" className="logo" onClick={closeMobileMenu}>
          <span className={`logo-text ${isScrolled ? 'hidden' : ''}`}>
            <i className="fas fa-brain"></i>
            Nicolette Rudmann
          </span>
          <div className={`logo-image ${isScrolled ? 'visible' : ''}`}>
            <img src="/images/profile/profile-headshot.jpeg" alt="Nicolette Rudmann" />
            <div className="logo-profile-info">
              <span className="logo-title">Profil</span>
              <span className="logo-name">Nicolette Rudmann</span>
              <span className="logo-role">Full-Stack Developerin</span>
            </div>
          </div>
        </a>
        
        {/* Mobile Menu Button */}
        <button 
          className={`mobile-menu-btn ${isScrolled ? 'scrolled' : ''} ${isMobileMenuOpen ? 'open' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav>
          {/* Desktop Navigation - vollständige Navigation */}
          <ul className={`nav-links desktop-nav ${isScrolled ? 'compact' : ''}`}>
            <li><a href="#skills">Skills</a></li>
            <li><a href="#projects">Projekte</a></li>
            <li><a href="#education">Ausbildung</a></li>
            <li><a href="#languages">Sprachen</a></li>
            <li><a href="#contact">Kontakt</a></li>
            <li><a href="#contact" className="contact-cta">Kontakt aufnehmen</a></li>
          </ul>
          
          {/* Mobile Navigation */}
          <ul className={`nav-links mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
            <li><a href="#skills" onClick={closeMobileMenu}>Skills</a></li>
            <li><a href="#projects" onClick={closeMobileMenu}>Projekte</a></li>
            <li><a href="#education" onClick={closeMobileMenu}>Ausbildung</a></li>
            <li><a href="#languages" onClick={closeMobileMenu}>Sprachen</a></li>
            <li><a href="#contact" onClick={closeMobileMenu}>Kontakt</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header; 